export function safeRedirectTarget(redir) {
    if (typeof redir !== "string") {
        return "/";
    }
    try {
        const url = new URL(redir, window.location.origin);
        if (url.origin !== window.location.origin) {
            return "/";
        }
        return url.pathname + url.search + url.hash;
    } catch {
        return "/";
    }
}
